/* eslint-disable max-len */
import { PerformanceClient } from '@agoda/performance-client'
import { messagingClient } from '../analytics'
import { ycs } from '../analytics/common/ycs'
import getPageTypeId from './pathNameMapper'

const getUserId = () => ycs.pageConfig.userId
const getWhitelabelId = () => ycs.pageConfig.whiteLabelId
const getOrigin = () => ycs.pageConfig.origin
const getLanguageId = () => ycs.pageConfig.languageId
const getDeviceTypeId = () => ycs.pageConfig.deviceTypeId

const getExperiment = () => Object.entries(ycs.pageConfig.exp)
    .filter(([_, value]) => value?.toLowerCase() === 'true' || value?.toLowerCase() === 'b')
    .map(([key]) => key)
    .join('')

const isPathMldc = (pathName: string) => pathName.startsWith('/mldc/')

const measureLanding = (pathName: string) => {
    const lowerPathName = pathName.toLowerCase()
    const appName = 'ycs-ssr'
    const pageTypeId = getPageTypeId(lowerPathName)
    if (!pageTypeId) {
        return
    }
    const performanceClient = new PerformanceClient(messagingClient, {
        userId: getUserId(),
        memberId: 0,
        cid: 0,
        aid: 0,
        trafficGroupId: 0,
        clientId: 0,
        devicePlatformId: getDeviceTypeId(),
        pageTypeId: pageTypeId,
        languageId: getLanguageId(),
        origin: getOrigin(),
        whiteLabelId: getWhitelabelId(),
    })
    const isMldc = isPathMldc(lowerPathName)

    performanceClient.measurePaintLargest({ appName: appName, exp: getExperiment(), isPathMldc: isMldc }, false) // For LCP
    performanceClient.measureInputFirstDelay({ appName: appName, exp: getExperiment(), isPathMldc: isMldc }, false) // For FID
    performanceClient.measureInteractionToNextPaint({ appName: appName, exp: getExperiment(), isPathMldc: isMldc }, false) // For INP replacement for FID in the future
    performanceClient.measurePaintFirst(Promise.resolve(), { appName: appName, exp: getExperiment(), isPathMldc: isMldc }) // For FCP
    const alcpPromise = performanceClient.measureAgodaLcp({ appName: appName, exp: getExperiment(), isPathMldc: isMldc }, false).await() // For ALCP
    performanceClient.measureCumulativeLayoutShift(alcpPromise, { appName: appName, exp: getExperiment(), isPathMldc: isMldc }) // For CLS
    performanceClient.measureTimeToFirstByte({ appName: appName, exp: getExperiment(), isPathMldc: isMldc }, false) // For Time to First Byte

    alcpPromise.then(() => {
        performanceClient.measureDocumentLoad(Promise.resolve(), { appName: appName, exp: getExperiment() })
        const interactive = performanceClient.measureInteractive(Promise.resolve(), { appName: appName, exp: getExperiment() })
        interactive.await().then(() => {
            performanceClient.measureTotalBlockingTime(interactive.await(), { appName: appName, exp: getExperiment() }, false)
        })
    })
}


export default measureLanding